import * as React from 'react';
//NoSearch import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
//NoSearch import InputBase from '@mui/material/InputBase';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
//NoSearch import SearchIcon from '@mui/icons-material/Search';
import AccountCircle from '@mui/icons-material/AccountCircle';
//import MailIcon from '@mui/icons-material/Mail';
import HomeIcon from '@mui/icons-material/Home';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PsychologyAltIcon from '@mui/icons-material/PsychologyAlt';
// import AssessmentIcon from '@mui/icons-material/Assessment';
// import LogoutIcon from '@mui/icons-material/Logout';
//import NotificationsIcon from '@mui/icons-material/Notifications';
import MoreIcon from '@mui/icons-material/MoreVert';
import { useAuth0 } from "@auth0/auth0-react";
import { LoginButton } from '../components/LoginButton';
import { useNavigate } from "react-router-dom";
import { Avatar /*, Icon */ } from '@mui/material';

/*NoSearch
const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));
*/
export default function PrimarySearchAppBar() {
  const { isAuthenticated, logout, user } = useAuth0();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] =
    React.useState<null | HTMLElement>(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleGamesNavigate = (event: React.MouseEvent<HTMLElement>) => {
    handleMenuClose();
    navigate("/games");
  }

  const handleSurveysNavigate = (event: React.MouseEvent<HTMLElement>) => {
    handleMenuClose();
    navigate("/surveys");
  }

  const handleProfileNavigate = (event: React.MouseEvent<HTMLElement>) => {
    handleMenuClose();
    navigate("/profile");
  }

  const handleHomeNavigate = (event: React.MouseEvent<HTMLElement>) => {
    handleMenuClose();
    navigate("/");
  }

  const handleLogout = (event: React.MouseEvent<HTMLElement>) => {
    handleMenuClose();
    logout({ logoutParams: { returnTo: window.location.origin } });
  }

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {/* <MenuItem onClick={handleGamesNavigate}>Games</MenuItem> */}
      <MenuItem onClick={handleProfileNavigate}>Profil</MenuItem>
      <MenuItem onClick={handleLogout}>Kijelentkezés</MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={handleHomeNavigate}>
        <IconButton size="large" aria-label="Back to homepage" color="inherit">
          {/* <Badge badgeContent={4} color="error"> */}
          <Badge>
            <HomeIcon />
          </Badge>
        </IconButton>
        {/* <p>Home</p> */}
        <p>Főoldal</p>
      </MenuItem>
      <MenuItem onClick={handleGamesNavigate}>
        <IconButton size="large" aria-label="Go to Games" color="inherit">
          <Badge>
            <DashboardIcon />
          </Badge>
        </IconButton>
        {/* <p>Games</p> */}
        <p>Játékok</p>
      </MenuItem>
      <MenuItem onClick={handleSurveysNavigate}>
        <IconButton size="large" aria-label="Go to Surveys" color="inherit">
          <Badge>
            <PsychologyAltIcon />
          </Badge>
        </IconButton>
        {/* <p>Surveys</p> */}
        <p>Kérdőívek</p>
      </MenuItem>
      {/* <MenuItem>
        <IconButton
          size="large"
          aria-label="show 17 new notifications"
          color="inherit"
        >
          <Badge badgeContent={17} color="error">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem> */}
      {/* <MenuItem onClick={handleProfileNavigate}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profil</p>
      </MenuItem>
      <MenuItem onClick={handleLogout}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <LogoutIcon />
        </IconButton>
        <p>Kijelentkezés</p>
      </MenuItem> */}
    </Menu>
  );

  return (
    <Box>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ mr: 2 }}
            onClick={handleMobileMenuOpen}
          >
            <MenuIcon />
          </IconButton>
          <img src={ process.env.PUBLIC_URL + '/favicon.ico' } alt="" style={{maxHeight: "2em"}}/>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ display: { xs: 'none', sm: 'block' } }}
          >
            FIPOK Portál
          </Typography>
          {/*NoSearch
	   <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search…"
              inputProps={{ 'aria-label': 'search' }}
            />
          </Search>
	  */}
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: 'flex', md: 'flex' } }}>
            {!isAuthenticated && (
              <LoginButton />
            )}
            {isAuthenticated && (
          <Tooltip title="Profil megnyitása">
              <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
              >
                {user && user.picture && (
                  <Avatar src={user.picture} />
                )}
                {!(user && user.picture) && (
                  <AccountCircle />
                )}
              </IconButton>
            </Tooltip>
            )}
          </Box>
          <Box sx={{ display: { xs: 'none', md: 'none' } }}>
            {!isAuthenticated && (
              <LoginButton />
            )}
            {isAuthenticated && (
              <IconButton
                size="large"
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
              >
                <MoreIcon />
              </IconButton>
            )}
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </Box>
  );
}
